import { useCommerce } from '@commerce'
import { formatCurrency, formatPrice } from '@commerce/product/use-price'
import { calculateUnitPrice } from '@pageFeatures/design/designUpload/components/VariantOptionSelection.utils'
import {
  NEXT_PUBLIC_BIGCOMMERCE_CHANNEL_CURRENCY,
  NEXT_PUBLIC_TAX_TYPE,
} from '@utils/client-side-config'

export function PriceSection({
  price,
  salePrice,
  currencyCode,
  quantity,
}: {
  price: number
  salePrice?: number
  currencyCode: string
  quantity: number | string
}) {
  const { locale } = useCommerce()
  const formattedPrice = formatPrice({
    amount: salePrice || price,
    currencyCode: currencyCode || NEXT_PUBLIC_BIGCOMMERCE_CHANNEL_CURRENCY,
    locale: 'en-US',
  })
  const formattedOriginalPrice = formatCurrency({
    amount: price,
    currencyCode: currencyCode || NEXT_PUBLIC_BIGCOMMERCE_CHANNEL_CURRENCY,
    locale,
  })

  const pricePerUnit = calculateUnitPrice({
    priceOfProduct: price,
    qtyOfProduct: quantity,
    locale,
  })

  const salePricePerUnit = calculateUnitPrice({
    priceOfProduct: salePrice,
    qtyOfProduct: quantity,
    locale,
  })

  return (
    <div className="flex gap-[12px] items-center">
      <div className="flex gap-[2px] uppercase" aria-label="Product price">
        {pricePerUnit ? (
          <span className="font-mori text-[20px] font-semibold lowercase text-acai">
            from {salePrice ? salePricePerUnit : pricePerUnit}
          </span>
        ) : (
          <span className="text-[20px] font-semibold text-core-tree">
            {formattedPrice}
          </span>
        )}

        {NEXT_PUBLIC_TAX_TYPE && (
          <span className="text-xl uppercase font-mori text-acai">
            {`+ ${NEXT_PUBLIC_TAX_TYPE}`}
          </span>
        )}
      </div>

      {salePrice && salePrice < price && (
        <div
          className="text-[18px] text-black-80 lowercase"
          aria-label="Original price"
        >
          was{' '}
          <span className="line-through">
            {pricePerUnit || formattedOriginalPrice}
          </span>
        </div>
      )}
    </div>
  )
}
